import type { ComponentType, ReactNode } from 'react'
import { ratingInfo } from '@/lib/tags'
import { cn } from '@/lib/utils'

const tone: Record<string, string> = {
  s: 'bg-success/12 text-success ring-success/25',
  q: 'bg-warning/12 text-warning ring-warning/25',
  e: 'bg-destructive/12 text-destructive ring-destructive/25',
}

export function RatingBadge({ rating, className, compact = false }: { rating: string; className?: string; compact?: boolean }) {
  const info = ratingInfo(rating)
  return (
    <span
      title={info.description}
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset',
        tone[rating] ?? 'bg-muted text-muted-foreground ring-border',
        className,
      )}
    >
      {compact ? info.short : info.label}
    </span>
  )
}

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn('inline-block size-5 animate-spin rounded-full border-2 border-current border-r-transparent', className)}
    />
  )
}

export function EmptyState({
  icon: Icon,
  title,
  children,
}: {
  icon: ComponentType<{ className?: string }>
  title: string
  children?: ReactNode
}) {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-6 py-20 text-center animate-rise">
      <span className="mb-5 flex size-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
        <Icon className="size-7" />
      </span>
      <h2 className="text-xl font-semibold">{title}</h2>
      {children && <div className="mt-2 text-sm text-muted-foreground">{children}</div>}
    </div>
  )
}
